import { graphql } from '@/graphql-setup'

export const REGISTER_LEARNING_DEMO_VIEW_MUTATION = graphql(`
  mutation RegisterLearningDemoView($demo: ID!) {
    registerLearningDemoView(demo: $demo) {
      progress {
        id
        status
        viewCount
      }
    }
  }
`)

export const REGISTER_LEARNING_DEMO_HEARTBEAT_MUTATION = graphql(`
  mutation RegisterLearningDemoHeartbeat($demo: ID!, $seconds: Int!) {
    registerLearningDemoHeartbeat(demo: $demo, seconds: $seconds) {
      progress {
        id
        watchedSeconds
      }
    }
  }
`)

export const SET_LEARNING_DEMO_COMPLETED_MUTATION = graphql(`
  mutation SetLearningDemoCompleted($demo: ID!, $completed: Boolean!) {
    setLearningDemoCompleted(demo: $demo, completed: $completed) {
      progress {
        id
        status
        completedAt
      }
    }
  }
`)
